import { Component, OnInit } from '@angular/core';
import { UtilFns } from '@utils';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';

export type ConsolidationCase = 'A' | 'B' | 'C';

export interface IConsolidationAction {
  loserConfigId: string;
  loserConfigName: string;
  productKey: string;
  productTypeName: string;
  case: ConsolidationCase;
  winnerConfigId?: string;
  winnerConfigName?: string;
  reasonC?: string;
  isForceApproval: boolean;
}

export interface IConsolidateMeSummaryParams {
  actions: IConsolidationAction[];
}

@Component({
  selector: 'prox-consolidate-me-summary-dialog',
  standalone: false,
  templateUrl: './consolidate-me-summary.dialog.component.html',
})
export class ConsolidateMeSummaryDialogComponent implements OnInit {
  actions: IConsolidationAction[] = [];
  caseA: IConsolidationAction[] = [];
  caseB: IConsolidationAction[] = [];
  caseC: IConsolidationAction[] = [];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig<IConsolidateMeSummaryParams>,
  ) {}

  ngOnInit(): void {
    const params = this.config.data;
    UtilFns.assertNonNull(params);
    this.actions = params?.actions ?? [];
    this.caseA = this.actions.filter((a) => a.case === 'A');
    this.caseB = this.actions.filter((a) => a.case === 'B');
    this.caseC = this.actions.filter((a) => a.case === 'C');
  }

  get hasActionable(): boolean {
    return this.caseA.length + this.caseB.length > 0;
  }

  onGoAhead() {
    this.ref.close({ confirmed: true });
  }

  onCancel() {
    this.ref.close(null);
  }

  public static async openDialog(dialogService: DialogService, data: IConsolidateMeSummaryParams) {
    const ref = dialogService.open(ConsolidateMeSummaryDialogComponent, {
      header: 'Consolidate Me — Planned Actions',
      closable: false,
      draggable: true,
      width: '900px',
      height: '80vh',
      maximizable: true,
      resizable: true,
      focusOnShow: false,
      data,
    });
    return (await firstValueFrom(ref.onClose)) as { confirmed: boolean } | null;
  }
}
